//@flow
import * as Immutable from 'immutable';

import {
    PjpMetricResponse,
    PjpMetricsItem,
    PjpMetricData,
    PjpMetricDataItem,
    PjpMetricTotal,
    PjpMetricValue
} from 'common/models/flow/PjpMetricResponse';
import type {
    PjpMetricResponseModelType,
    PjpMetricsItemModelType,
    PjpMetricDataModelType,
    PjpMetricDataItemModelType,
    PjpMetricTotalModelType,
    PjpMetricValueModelType
} from 'common/models/flow/PjpMetricResponse';

class InternalPjpMetricResponse extends PjpMetricResponse {
    static fromJS(json: PjpMetricResponseModelType): InternalPjpMetricResponse {
        const state: Object = Object.assign({}, json);
        state.metricsData = Immutable.List(state.metricsData).map(item =>
            InternalPjpMetricsItem.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalPjpMetricsItem extends PjpMetricsItem {
    static fromJS(json: PjpMetricsItemModelType): InternalPjpMetricsItem {
        const state: Object = Object.assign({}, json);
        state.currentPlan = InternalPjpMetricData.fromJS(state.currentPlan);
        state.existingPlan = state.existingPlan
            ? InternalPjpMetricData.fromJS(state.existingPlan)
            : state.existingPlan;
        return new this(Immutable.Map(state));
    }
}

class InternalPjpMetricData extends PjpMetricData {
    static fromJS(json: PjpMetricDataModelType): InternalPjpMetricData {
        const state: Object = Object.assign({}, json);
        state.metricDataItems = state.metricDataItems
            ? Immutable.List(state.metricDataItems).map(item =>
                  InternalPjpMetricDataItem.fromJS(item)
              )
            : state.metricDataItems;
        state.metricTotal = InternalPjpMetricTotal.fromJS(state.metricTotal);
        state.previousMetricTotal = state.previousMetricTotal
            ? InternalPjpMetricTotal.fromJS(state.previousMetricTotal)
            : state.previousMetricTotal;
        return new this(Immutable.Map(state));
    }

    get metricDataItems(): ?Immutable.List<PjpMetricDataItem> {
        return this._state.get('metricDataItems');
    }

    get metricTotal(): InternalPjpMetricTotal {
        return this._state.get('metricTotal');
    }

    get previousMetricTotal(): ?InternalPjpMetricTotal {
        return this._state.get('previousMetricTotal');
    }

    isDataEmpty() {
        const { metric } = this;
        if (!metric) {
            return true;
        }
        return false;
    }
}

class InternalPjpMetricDataItem extends PjpMetricDataItem {
    static fromJS(json: PjpMetricDataItemModelType): InternalPjpMetricDataItem {
        const state: Object = Object.assign({}, json);
        state.metricDataRow = Immutable.Map(state.metricDataRow).map(item =>
            InternalPjpMetricValue.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalPjpMetricTotal extends PjpMetricTotal {
    static fromJS(json: PjpMetricTotalModelType): InternalPjpMetricTotal {
        const state: Object = Object.assign({}, json);
        state.metricDataRow = Immutable.Map(state.metricDataRow).map(item =>
            InternalPjpMetricValue.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalPjpMetricValue extends PjpMetricValue {
    static fromJS(json: PjpMetricValueModelType): InternalPjpMetricValue {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalPjpMetricResponse as PjpMetricResponse,
    InternalPjpMetricsItem as PjpMetricsItem,
    InternalPjpMetricData as PjpMetricData,
    InternalPjpMetricDataItem as PjpMetricDataItem,
    InternalPjpMetricTotal as PjpMetricTotal,
    InternalPjpMetricValue as PjpMetricValue
};
